var Parallax = {
    init:function(){
        console.log('init parallax')
        var parallax = gsap.utils.toArray($('[parallax]').find('img'));
        parallax.forEach(function(section) {
            gsap.to(section, {
                yPercent: 100,
                ease: "none",
                scrollTrigger: {
                    trigger: section,
                    start: "top top", // the default values
                    end: "bottom top",
                    scrub: true
                },
            });

        });
    }
}

$(window).load(function(){
    if($('[parallax]').length && window.innerWidth > 990){
        Parallax.init();
    }
})
